import React, { useEffect } from 'react';
import CardDashboardVazio from './CardDashboardVazio';
import '../Estilos/CardDashboard.css';
import ReactTooltip from 'react-tooltip';
import { checkColor, checkStatus } from '../Funções/CardStatus';
import { useMediaQuery } from 'react-responsive';
/**
 * @param tipo (string) Tipo de card.
 * @param width (string) Largura do card.
 * @param top (string) Distância top.
 * @param filtroSensor(string[])
 */
export default function CardDashboardAmbiente(props) {
  const isMobile = useMediaQuery({ query: `(max-width: 920px)` });
  //const status=props.ok?"LOK":props.ok==false?"LNG":"LIDLE"
  const unidade = props.tipo.search('TEMPERATURA') != -1 ? '°C' : '%';

  const getColor = () => {
    if (props.ok === undefined) return '#626262';
    else return checkColor(props.ok);
  };

  const getStatus = () => {
    if (props.ok === undefined) return 'IDLE';
    else return checkStatus(props.ok);
  };

  return (
    <CardDashboardVazio
      height={250}
      maxW={600}
      minW={props.minW ? props.minW : 0}
      classe={'L' + getStatus()}
      top={props.top}
      width={isMobile ? '45%' : props.width}
      valor={90}
      id="00:23:45:66"
      nome="Geladeira 1"
      porta={true}
    >
      <div className={`CardView `}>
        <div id="CardDetalhes">
          <div id="TituloCardView">
            <h4 id="FonteCard">{props.tipo}</h4>
          </div>
          {props.filtroSensor ? (
            <>
              <img
                src={require('../Icones/icon info.svg').default}
                data-tip
                data-for="registerTip"
                alt="info"
              />

              <ReactTooltip
                id="registerTip"
                backgroundColor="black"
                multiline={true}
                place="top"
                effect="solid"
              >
                {props.filtroSensor.map((i) => {
                  return (
                    <div className="toolTip">
                      <p>{i}</p>
                    </div>
                  );
                })}
              </ReactTooltip>
            </>
          ) : null}
        </div>

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            margin: 0,
            padding: 0,
            justifyContent: 'center',
            flexDirection: 'column',
            height: 120,
            width: 120,
            borderRadius: 60,
            border: `3px solid ${getColor()}`,
          }}
        >
          <h2 className={`Valor ${getStatus()}`}>
            {props.valor}
            {unidade}
            <h6 id="FonteID" style={{ paddingTop: 0 }}>
              {props.data === 'NaN/NaN/NaN NaN:NaN' ? '' : props.data}
            </h6>
          </h2>
        </div>

        <div style={{ display: 'flex', width: '100%', height: 40 }}>
          <h6 id="FonteID" style={{ paddingTop: 8 }}>
            {props.minimo}° min - {props.maximo}° máx
          </h6>
        </div>
      </div>
    </CardDashboardVazio>
  );
}
